<template>
  <DefaultLayout>
    <ProfileUserFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('User Profiles') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ profileUsers.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <ProfileUserCreateAction cssClass="ms-1" @created="reload" v-if="can('USER_MANAGE')" />
      </template>
    </ProfileUserFilter>

    <ProfileUserList :profileUsers="profileUsers" :loading="loading" :autoLazyLoad="!!pagination.nextPageURI"
      @deleted="reload" @updating="loading = true" @updated="reload" @next="nextPage" />
  </DefaultLayout>
</template>

<script>
import api from "@/api.js";
import {
  duplicate,
  flattenUrlObject,
} from "@/tools/object.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ProfileUserCreateAction from "@/components/profileUser/ProfileUserCreateAction.vue";
import ProfileUserFilter from "@/components/profileUser/ProfileUserFilter.vue";
import ProfileUserList from "@/components/profileUser/ProfileUserList.vue";

export default {
  components: {
    DefaultLayout,
    ProfileUserCreateAction,
    ProfileUserFilter,
    ProfileUserList,
  },
  data() {
    return {
      profileUsers: [],
      filters: {},
      loadTimeout: null,
      loading: true,
      pagination: {
        requestId: 0,
        limit: 10,
        records: [],
        loadPages: 1,
        nextPageURI: null,
        currentPage: 1,
        total: null,
      },
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Local Users'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!this.can('USER_MANAGE')
        && !this.can('USER_ACCESS')) {
        this.$router.push({
          name: 'Index',
        });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  computed: {
    params() {
      let params = duplicate(this.filters);
      params.acl = 'externalUserProfile';
      params.limit = this.pagination.limit;

      flattenUrlObject(params);

      return params;
    },
  },
  methods: {
    load(force) {
      clearTimeout(this.loadTimeout);
      this.loading = true;
      this.pagination.requestId++;

      if (!force) {
        this.loadTimeout = setTimeout(() => {
          this.load(true);
        }, 250);
        return;
      }

      this.pagination.records = [];
      this.pagination.currentPage = 1;
      this.loadPages(this.pagination.requestId, `users/profiles`, this.params);
    },
    loadPages(requestId, uri, params) {
      api.getWithHeaders(uri, params).then((profileUsersResult) => {
        if (requestId != this.pagination.requestId) return;

        const profileUsers = profileUsersResult.data,
          headers = profileUsersResult.headers;

        this.pagination.records = [
          ...this.pagination.records,
          ...profileUsers,
        ];

        this.pagination.nextPageURI = headers.get('X-PAGINATE-NEXT');
        this.pagination.total = headers.get('X-PAGINATE-COUNT');

        if (this.pagination.currentPage < this.pagination.loadPages
          && this.pagination.nextPageURI) {
          this.pagination.currentPage++;
          this.loadPages(requestId, this.pagination.nextPageURI);
          return;
        } else {
          this.pagination.loadPages = this.pagination.currentPage;
        }

        this.profileUsers = [...this.pagination.records];
        this.loading = false;
      });
    },
    nextPage() {
      this.loading = true;
      this.pagination.currentPage++;
      this.pagination.loadPages = this.pagination.currentPage;
      this.loadPages(++this.pagination.requestId, this.pagination.nextPageURI);
    },
    reload() {
      this.load();
    },
  },
};
</script>